module.exports = function () {
  var els = '.grid-group-member, .event-block-outer, .hero-outer, .hero.img-outer, .page__content .col, .full-width-cta'

  var $el = $('.no-touch').find(els)

  function onScroll () {
    $el.each(function () {
      var el = $(this)

      var idx = ($(this).index() + 4) % 4

      if (el.parent().hasClass('grid-three-up')) {
        idx = ($(this).index() + 4) % 3
      }

      if (window.pageYOffset + window.innerHeight > el.offset().top + 25) {
        setTimeout(function () {
          el.addClass('triggered')
        }, 50 * idx)
      } else {
        el.removeClass('triggered')
      }
    })
  }

  if ($('body').hasClass('no-touch')) {
    onScroll()
    $(window).on('load scroll resize', onScroll)
  }
}
